import React, { useEffect, useState } from 'react';
import styles from './HandbookImageBackgroundHeader.module.scss';
import Title from '../../Components/Title/Title';
import Description from '../../Components/Description/Description';
import Button from '../../Components/Button/Button';
import Image from '../../Components/Image/Image';

const HandbookImageBackgroundHeader = ({ api }) => {
  const [date, setDate] = useState();
  const { event_start, event_end } = api.attributes;

  useEffect((_) => {
    const currentDate = new Date().toISOString();
    setDate(currentDate);
  }, []);

  if (!!event_start && !!event_end && (!date || event_start > date || date > event_end)) return null;

  return (
    <section id={api?.id} className={`wrapper ${styles.sectionHandbook}`}>
      <Title
        animationData={{ animation: 'fade-up', animationDelay: '300', animationDuration: '1000', animationEasing: 'easy-in-out' }}
        title={api.attributes.sectionTitle}
        type="product"
      />
      <div
        className={styles.sectionContainer}
        data-aos="fade-up"
        // data-aos-anchor-placement="top-center"
        data-aos-once="false"
        // data-aos-delay="300"
        data-aos-duration="500"
      >
        <div className={styles.contentContainer}>
          {!!api.attributes.title && (
            <p className={styles.number}>
              {api.attributes.title}
              <span className={styles.sign}>{api.attributes.unit}</span>
            </p>
          )}
          <div className={styles.textContainer}>
            {!!api.attributes.subTitle && <h4 className={styles.subTitle} dangerouslySetInnerHTML={{ __html: api.attributes.subTitle }} />}
            <Description api={api} type="product" />
            <Button api={api} type="btnBlack" />
          </div>
        </div>
        <Image
          animationData={{ animation: 'zoom-in', animationDuration: '1000', animationEasing: 'easy-in-out' }}
          properties={api.attributes}
          type="product overflowingImages"
        />
      </div>
    </section>
  );
};

export default HandbookImageBackgroundHeader;
